// This function allow to reference async chunks
__webpack_require__.miniCssF = function(chunkId) {
	// return url for filenames based on template
	return "static/css/" + chunkId + "." + {"57":"eed2c708","193":"c7ba9025","485":"b49cffe0","486":"c634549a","526":"fe52f9c6","783":"8d4a47a1","796":"b897a0aa","890":"406a915f","971":"a6bb472e"}[chunkId] + ".chunk.css";
};